// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1hJKF","buttons":"SendReceipts_buttons__1kGOD","email":"SendReceipts_email__1ITVi","bookApptTitle":"SendReceipts_bookApptTitle__O7I-n"};